<app-quick-list-view *ngIf="!dataLoading && variablesList?.length" [linkDetails]="variablesList" (linkSelected)="variableSelectionChange($event)">
</app-quick-list-view>
<div class="m-0 mdc-p-34" *ngIf="dataLoading">
  <mat-spinner style="margin: 0 auto;"></mat-spinner>
</div>
<div *ngIf="!dataLoading && !variablesList?.length">
  {{'NO_DATA_FOR_SELECTION' | translate}}
</div>